import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import styled from 'styled-components';

const Center = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 25%;
`

export default class Spinner extends Component {
  render() {
    if(this.props.center) {
      return (
        <Center>
          <FontAwesome name="spinner" size="4x" spin/>
        </Center>
      )
    } else {
      return (
        <div>
          <FontAwesome name="spinner" size="2x" spin/>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/spinner/spinner.js